import { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getBusinessPartnerStatus } from '../../../api/v2/businessPartner';
import { StoreContext } from '../../Store';
import CustomerValidation from '../../CustomerValidation';

const CM8ClientValidation = () => {
  const store = useContext(StoreContext);
  const navigate = useNavigate();
  const { id } = useParams();

  const [status, setStatus] = useState({
    id: null,
    companyName: '',
    cabieStatus: '',
    cabieStatusValid: false,
    dbStatus: '',
    dbStatusValid: false,
    billableCustomerValid: '',
    billableCustomer: false,
    cm8Approved: '',
    cm8ApprovedValid: false,
  });

  useEffect(() => {
    async function fetch() {
      try {
        const data = await getBusinessPartnerStatus(id);
        setStatus({
          id: data.id,
          companyName: data.companyName,
          cabieStatus: data.cabieStatus,
          cabieStatusValid: data.cabieStatusValid,
          dbStatus: data.dbStatus,
          dbStatusValid: data.dbStatusValid,
          billableCustomer: data.billableCustomer,
          billableCustomerValid: data.billableCustomerValid,
          cm8Approved: data.cm8Approved,
          cm8ApprovedValid: data.cm8ApprovedValid,
        });
      } catch (error) {
        console.error('Error fetching NBP list:', error);
      }
    }

    fetch();
  }, [id]);

  const cancelAction = () => {
    navigate(`/load/cm8/client`);
  };

  const createLoad = () => {
    navigate(`/load/cm8/${id}`);
  };

  const handleKebabClick = () => {
    store.clientID[1](id);
    navigate('/BusinessPartners?from=cm8&id=' + status.id + '&companyid=' + id);
  };

  const customerIsCM8Valid = status.cabieStatusValid && status.dbStatusValid && status.billableCustomerValid;

  return (
    <CustomerValidation
      isValid={customerIsCM8Valid}
      companyName={status.companyName}
      companyId={status.id}
      onKebabClick={handleKebabClick}
      onCancel={cancelAction}
      onCreateLoad={createLoad}
      cabieStatusValid={status.cabieStatusValid}
      cabieStatus={status.cabieStatus}
      billableCustomerValid={status.billableCustomerValid}
      billableCustomer={status.billableCustomer}
      dbStatusValid={status.dbStatusValid}
      dbStatus={status.dbStatus}
      cm8Approved={status.cm8Approved}
      cm8ApprovedValid={status.cm8ApprovedValid}
      heading="CM8 Validation"
      isCustomaite
    />
  );
};

export default CM8ClientValidation;
